import {css} from '@emotion/react';
import styled from '@emotion/styled';
import {Stack} from '@travel-frontend/ui-components';

export const TextWrapper = styled(Stack)`
  display: none;

  ${({theme}) =>
    theme.respondTo(
      'md',
      css`
        display: flex;
        text-shadow: 0 1px 4px rgba(0, 0, 0, 0.25);
        padding: 8px 16px;
        z-index: 1;
        flex-grow: 1;
      `
    )}
`;
